import BaseModel from '@/api/RestModels/baseModel';
import api from './client';

class RunRestModel extends BaseModel {
  path = 'runDetails'

  get = async (pathExtension) => {
    if (pathExtension) return api.get(`${this.path}/${pathExtension}`).json();
    return api.get(`${this.path}`).json()
  }

  getInfo = async (query) => api.get(`${this.path}/information${query}`).json();

  getParticipantStatus = async () => api.get(`${this.path}/participantStatus`).json();

  getDocumentNames = async () => api.get(`${this.path}/documentNames`).json();

  getDocument = async (path) => api.get(`${this.path}/${path}`, { stream: true }).blob()
}

export default new RunRestModel();
